import { useContext, useEffect, useMemo, useState } from "react";
import styled, { css } from "styled-components";
import CanvasAddProductButton from "../../../sharable/CanvasAddProductButton";
import CestaBasicaKitProduct from "./CestaBásicaProduct";
import EncarteTrialVersionMarketingMessage from "../../../sharable/EncarteTrialVersionMarketingMessage";
import FooterStyles, {
  getPanfletoFooterRowHeight,
} from "../../../sharable/SocialCanvasFooterStyles";
import { BRAND_VIEW } from "../../ToolBarMenuViews/Toolbar";
import WorkspaceContext from "../../WorkspaceContext";
import {
  BrandLogo,
  calcProductStylesOcurrence,
  Canvas,
  GridProducts,
  Header,
} from "../Canvas/CanvasGeneralStyles";
import {
  CANVAS_TARGET_CLASSNAME,
  CESTA_BASICA_KIT_DIM,
  LOGO_SIZE_MEDIUM,
} from "../EncarteConstants";
import CestaBasicKitDisplayPrice from "./CestaBasicaKitDisplay";
import PremiumContentProtectiveLayer from "../../../sharable/PremiumContentProtectiveLayer";
import { useOutletContext } from "react-router";

const CestaBasicaKitContainer = styled(Canvas)`
  ${({ canvasScale, styles }) => css`
    background-position-y: ${-300 * canvasScale}px;
    .marketing-message {
      font-size: ${26 * canvasScale}px;
    }
  `}
  grid-template-rows: min-content 1fr min-content min-content;
`;
const CestaBasicaKitHeader = styled(Header)`
  ${({ styles, canvasScale }) => css`
    height: ${CESTA_BASICA_KIT_DIM.header * canvasScale}px !important;
  `}
`;
const CestaBasicaKitGridProducts = styled(GridProducts)``;

export default function CestaBasicaKitCanvasViewer({
  grid,
  products,
  canvasScale,
  isProductClickable,
}) {
  const { isAccountPremium } = useOutletContext();
  const { styles, userBrand, encarte, model, scrollIntoMenu } =
    useContext(WorkspaceContext);

  const headerAndFooterStyles = useMemo(
    () => calcProductStylesOcurrence(products),
    [products],
  );

  const footerRowHeight = getPanfletoFooterRowHeight(
    styles.footerStyle,
    canvasScale,
  );

  return (
    <CestaBasicaKitContainer
      canvasScale={canvasScale}
      styles={styles}
      model={model}
      dimensions={CESTA_BASICA_KIT_DIM}
      className={CANVAS_TARGET_CLASSNAME}
      footerRowHeight={footerRowHeight}
    >
      {!isAccountPremium && (
        <PremiumContentProtectiveLayer
          className="format-premium"
          buttonSize="5"
        />
      )}
      <CestaBasicaKitHeader styles={styles} canvasScale={canvasScale}>
        <BrandLogo
          logo={userBrand.logoURLTmp}
          canvasScale={canvasScale}
          logoSize={styles.logoSize}
          logoStyle={styles.logoStyle}
          headerStyles={headerAndFooterStyles}
          position={{ bottom: 15, right: 10 }}
          size={LOGO_SIZE_MEDIUM}
          onClick={() => {
            if (isProductClickable) scrollIntoMenu(BRAND_VIEW);
          }}
        />
      </CestaBasicaKitHeader>
      {grid && products?.length > 0 ? (
        <>
          {/* Product grid keeps the same interaction model as other social formats. */}
          <CestaBasicaKitGridProducts
            grid={grid}
            styles={styles}
            canvasScale={canvasScale}
          >
            {products.map((product, i) => (
              <CestaBasicaKitProduct
                product={product}
                canvasScale={canvasScale}
                styles={styles}
                index={i}
                isProductClickable={isProductClickable}
                productsLength={products.length}
              />
            ))}
          </CestaBasicaKitGridProducts>
          {/* Kit total bar uses quantity-aware sum from the dedicated hook. */}
          <CestaBasicKitDisplayPrice
            label="Você só paga:"
            canvasScale={canvasScale}
            products={products}
          />
          <EncarteTrialVersionMarketingMessage
            canvasScale={canvasScale}
            className="marketing-message"
          />
        </>
      ) : (
        <CanvasAddProductButton dimensions={CESTA_BASICA_KIT_DIM} />
      )}
      {headerAndFooterStyles && (
        <FooterStyles
          headerAndFooterStyles={headerAndFooterStyles}
          canvasScale={canvasScale}
        />
      )}
    </CestaBasicaKitContainer>
  );
}
